<template>
  <Item
    :item="item"
    :class="{ delisted: !listed, own: show_mine }"
    :links="[
      ITEM_LINK.screenshot,
      ITEM_LINK.inspect,
      ITEM_LINK.view_at_steam,
      ITEM_LINK.create_buy_order,
      ITEM_LINK.bulk_buy,
      ITEM_LINK.favorites,
      ITEM_LINK.check_on_market,
      ITEM_LINK.bump,
      ITEM_LINK.buy,
    ]"
    :selected="in_cart"
    :bot="true"
    :picture_width="pic_width"
    :picture_height="pic_height"
  >
    <template #itemTop>
      <slot name="itemTop" />
      <div v-if="item.bestseller" class="tag tag-bestseller">
        <img src="@/asset/icon/medal.svg" class="img-medal" alt="Bestseller">
        <span>#{{ item.bestseller }}</span>
      </div>
      <ItemTimer :item="item" />
    </template>
    <template v-if="!listed" #itemBtns>
      <button class="btn btn-primary btn-cta btn-disabled">
        <span>{{ $t('market.not_available') }}</span>
      </button>
    </template>
    <template v-else-if="own" #itemBtns>
      <button class="btn btn-primary btn-cta" @click="handleItem">
        <span>{{ $t('market.details') }}</span>
      </button>
    </template>
    <template v-else #itemBtns>
      <button v-if="!in_cart" class="btn btn-primary btn-cta" @click="checkUserLogged($router, () => addToCart(item))">
        <span>{{ $t('market.cart.add_to_cart') }}</span>
      </button>
      <button v-if="in_cart" class="btn btn-danger btn-cta" @click="removeFromCart(item)">
        <span>{{ $t('market.cart.remove_from_cart') }}</span>
      </button>
    </template>
  </Item>
</template>

<script setup>
import ItemTimer from '@/component/item/ItemTimer.vue';
import Item from '@/component/market/Item.vue';
import { ITEM_LINK } from '@/facade/enum.js';
import { getItemTo } from '@/helper/steam.js';
import { addToCart, isInCart, removeFromCart } from '@/hook/market/cart.js';
import { pushRoute } from '@/facade/router.js';
import { INVENTORY_STATUS_GROUP } from '@common/enum/market.js';
import { computed } from 'vue';
import { checkUserLogged } from '@/helper/user.js';
import { pic_width, pic_height } from '@/hook/mobile/breakpoint.js';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
  hideMine: {
    type: Boolean,
    default: false,
  },
});

const in_cart = computed(() => isInCart(props.item));
const listed = computed(() => INVENTORY_STATUS_GROUP.selling.includes(props.item.status));
const own = computed(() => props.item.is_mine);
const show_mine = computed(() => props.item.is_mine && !props.hideMine);

const handleItem = () => {
  pushRoute(getItemTo(props.item));
};
</script>
